export default __webpack_public_path__ + "static/media/Blueprint badge.6518f76e.svg";